<div class="modal-header">
  <h3 class="modal-title"> {{ title | translate }}</h3>
  <button type="button" class="close" (click)="onNoClick()">
    <span aria-hidden="true">×</span>
  </button>
</div>
<div class="modal-body" style="display: block; max-height: 88%;">
  <p *ngIf="!hideIcon" class="modal-body-alert">
    <fa-icon [icon]="faExclamationTriangle"></fa-icon>
  </p>
  <h4 [innerHTML]="message | translate "></h4>
</div>
<div class="modal-footer justify-content-between" style="padding: 0px;padding-top: 10px;text-align: center;">
  <div *ngIf="!hideNoButton" [ngClass]="{'d-none d-md-block col-md-6': !hideYesButton, 'col-12': hideYesButton}">
    <button type="button" class="btn btn-default btn-dialog" (click)="onNoClick()">{{ noCaption | translate }}</button>
  </div>
  <div *ngIf="!hideYesButton" [ngClass]="{'col-12 col-md-6 text-right': !hideNoButton, 'col-12': hideNoButton}">
    <button type="button" class="btn btn-primary btn-dialog" [mat-dialog-close]="true" cdkFocusInitial>{{ yesCaption | translate }}</button>
  </div>
</div>
